import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Auth.css';

export default function Register() {
  const [form, setForm] = useState({ company_name:'', full_name:'', email:'', phone:'', vat_number:'', password:'', confirm_password:'' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPw, setShowPw] = useState(false);   // Fix #9
  const { register } = useAuth();
  const navigate = useNavigate();

  const set = (k, v) => setForm(f => ({...f, [k]: v}));

  // Fix #15: basic phone validation
  const validatePhone = (phone) => /^[\d\s\+\-\(\)]{7,20}$/.test(phone.trim());

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.password !== form.confirm_password) {
      setForm(f => ({...f, confirm_password: ''}));
      return setError('Passwords do not match');
    }
    if (form.password.length < 8) return setError('Password must be at least 8 characters');
    if (!validatePhone(form.phone)) return setError('Please enter a valid telephone number');
    setLoading(true);
    try {
      await register(form);
      setSuccess(true);
    } catch(err) {
      setError(err.response?.data?.error || 'Registration failed. Please try again.');
    }
    setLoading(false);
  };

  if (success) return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-success-icon">✓</div>
        <h2>Registration Submitted</h2>
        <p className="auth-success-text">Thank you for registering with ElevenNorth &amp; Co. Your application is now being reviewed. We'll be in touch by email once your account is approved.</p>
        <Link to="/" className="btn-primary" style={{justifyContent:'center',marginTop:'24px'}}>Return to Home</Link>
      </div>
    </div>
  );

  return (
    <div className="auth-page">
      <div className="auth-card auth-card-wide">
        <div className="auth-header">
          <Link to="/" className="auth-logo">ElevenNorth <span>&amp; Co.</span></Link>
          <p className="tag">Wholesale Access</p>
          <h1 className="auth-title">Register as an<br/><em>Authorised Buyer</em></h1>
          <p className="auth-sub">Fill in your business details below. Our team will review your application and approve your account.</p>
        </div>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={submit} className="auth-form">
          <div className="form-row">
            <div className="form-group">
              <label>Company Name *</label>
              <input required value={form.company_name} onChange={e=>set('company_name',e.target.value)} placeholder="Your company name" />
            </div>
            <div className="form-group">
              <label>Full Name *</label>
              <input required value={form.full_name} onChange={e=>set('full_name',e.target.value)} placeholder="Your full name" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Email Address *</label>
              <input required type="email" value={form.email} onChange={e=>set('email',e.target.value)} placeholder="you@company.com" />
            </div>
            <div className="form-group">
              <label>Telephone Number *</label>
              <input required value={form.phone} onChange={e=>set('phone',e.target.value)} placeholder="+44..." />
            </div>
          </div>
          <div className="form-group">
            <label>VAT Number <span className="optional">(optional)</span></label>
            <input value={form.vat_number} onChange={e=>set('vat_number',e.target.value)} placeholder="GB123456789" />
          </div>
          <div className="form-divider" />
          <div className="form-row">
            <div className="form-group">
              <label>Password *</label>
              <div style={{position:'relative'}}>
                <input required type={showPw ? 'text' : 'password'} value={form.password} onChange={e=>set('password',e.target.value)} placeholder="Min. 8 characters" style={{paddingRight:'44px'}} />
                <button type="button" onClick={()=>setShowPw(s=>!s)} style={{position:'absolute',right:'12px',top:'50%',transform:'translateY(-50%)',background:'none',border:'none',cursor:'pointer',color:'var(--gray)',fontSize:'12px'}}>
                  {showPw ? 'Hide' : 'Show'}
                </button>
              </div>
            </div>
            <div className="form-group">
              <label>Confirm Password *</label>
              <input required type={showPw ? 'text' : 'password'} value={form.confirm_password} onChange={e=>set('confirm_password',e.target.value)} placeholder="Repeat password" />
            </div>
          </div>
          <div className="alert alert-info" style={{marginTop:0}}>
            After submitting, your registration will be reviewed by our team. You'll receive an email once your account is approved and you can access wholesale pricing.
          </div>
          <button type="submit" className="btn-terracotta" style={{width:'100%',justifyContent:'center',padding:'16px'}} disabled={loading}>
            {loading ? 'Submitting...' : 'Submit Registration Request'}
          </button>
        </form>

        <p className="auth-switch">Already have an account? <Link to="/login">Log in here</Link></p>
      </div>
    </div>
  );
}
